import React from 'react';
import { NextPage } from 'next';
import initGraphQLClient from '../client/graphql/initGraphQLClient';
import { withError, withGetServerSideError } from '../client/hocs/with-server-side-error/withServerSideError';
import { EDITORIAL_CONTENT_PAGE_QUERY } from '../client/graphql/queries/editorialContentPage';
import EditorialContentPage, { EditorialContentPageProps } from '../client/components/editorial-content-page/EditorialContentPage';
import { EditorialContentPageQueryResponse } from '../domain/graphcms';

export type RealEstateAgentsTrainingProps = EditorialContentPageProps;

export const RealEstateAgentsTraining: NextPage<RealEstateAgentsTrainingProps> = (props) => (
  <EditorialContentPage {...props} />
);

export const getServerSideProps = withGetServerSideError<RealEstateAgentsTrainingProps>(async () => {
  const graphQLClient = initGraphQLClient();
  const { data: { editorialContentPage } } = await graphQLClient.query<EditorialContentPageQueryResponse>({
    query: EDITORIAL_CONTENT_PAGE_QUERY,
    variables: {
      contentId: 'cmcbozxqxqagn07uks4po1pzi',
    },
  });

  const {
    seo, title, mainContent, secondaryContent,
  } = editorialContentPage;

  return {
    props: {
      SEO: {
        title: seo.title,
        description: seo.description,
      },
      title: title.markdown,
      mainContent: mainContent.json,
      mainContentReferences: mainContent.references,
      secondaryBlocks: secondaryContent,
    } as RealEstateAgentsTrainingProps,
  };
});
export default withError(RealEstateAgentsTraining);
